/* @flow */

import type { RoleList } from './defs';
import { Roles } from './defs';

/////////////////////////////
// Cost center permissions //
/////////////////////////////
// Create Permissions //
////////////////////////
export const create: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

// Create Permissions > New cost center
export const createNewCostCenter: RoleList = [...create];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

// Update Permissions > Edit cost center
export const updateEditCostCenter: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ASSET_MANAGER,
  ...update,
];

// Update Permissions > Assign projects to cost center
export const updateAssignProjects: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.SYSTEM_ADMIN_REGIONAL,
  ...update,
];

// Update Permissions > Unarchive cost center
export const updateUnarchiveCostCenter: RoleList = [...update, Roles.MANAGER];

// Update Permissions > Archive cost center
export const updateArchiveCostCenter: RoleList = [...update, Roles.MANAGER];

// Update Permissions > Toggle cost center status
export const toggleCostCenterStatus: RoleList = [...update, Roles.MANAGER];

// Update Permissions > Remove projects from cost center
export const updateRemoveProjects: RoleList = [Roles.MANAGER, Roles.PURCHASER, ...update];
